import {createFileRoute} from '@tanstack/react-router';
import {SavingsAccountsCloseCallback} from 'features/deposit/close/SavingsAccountsCloseCallback';

export const Route = createFileRoute(
  '/_protected/savings-close/$id/$accountNumber',
)({
  component: SavingsAccountsCloseCallback,
  validateSearch: (search) => {
    return {
      status: search.status as string | undefined,
    };
  },
});
